import React from 'react';

const MatchingChart = () => {
  return (
    <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
      <p className="text-gray-500">AI Matching Performance Chart</p>
    </div>
  );
};

export default MatchingChart;